(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["perfume-category-product-row"] && !Shopify.designMode) return;
  try {
    
  class PerfumeCategoryProductRow extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('[data-pf-row-track]');
      this.prev = this.querySelector('[data-pf-row-prev]');
      this.next = this.querySelector('[data-pf-row-next]');

      if (!this.track) return;

      if (this.prev) {
        this.prev.addEventListener('click', () => this.scrollBy(-1));
      }

      if (this.next) {
        this.next.addEventListener('click', () => this.scrollBy(1));
      }
    }

    scrollBy(direction) {
      const firstItem = this.track.querySelector('.pf-category-row__item');
      const distance = firstItem ? firstItem.clientWidth + 18 : 320;
      this.track.scrollBy({ left: distance * direction, behavior: 'smooth' });
    }
  }

  if (!customElements.get('perfume-category-product-row')) {
    customElements.define('perfume-category-product-row', PerfumeCategoryProductRow);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["perfume-hero-slider"] && !Shopify.designMode) return;
  try {
    
  class PerfumeHeroSlider extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('[data-pf-hero-track]');
      this.slides = Array.from(this.querySelectorAll('[data-pf-hero-slide]'));
      this.dots = Array.from(this.querySelectorAll('[data-pf-hero-dot]'));
      this.prevButton = this.querySelector('[data-pf-hero-prev]');
      this.nextButton = this.querySelector('[data-pf-hero-next]');
      this.index = 0;

      if (!this.track || this.slides.length < 2) return;

      this.dots.forEach((dot) => {
        dot.addEventListener('click', () => this.goTo(Number(dot.dataset.pfHeroDot)));
      });

      if (this.prevButton) {
        this.prevButton.addEventListener('click', () => this.goTo(this.index - 1));
      }

      if (this.nextButton) {
        this.nextButton.addEventListener('click', () => this.goTo(this.index + 1));
      }

      this.track.addEventListener('scroll', () => {
        window.clearTimeout(this.scrollTimer);
        this.scrollTimer = window.setTimeout(() => this.syncFromScroll(), 80);
      });

      if (this.dataset.autoplay === 'true') {
        this.startAutoplay();
        this.addEventListener('mouseenter', () => this.stopAutoplay());
        this.addEventListener('mouseleave', () => this.startAutoplay());
      }
    }

    goTo(index) {
      const total = this.slides.length;
      this.index = (index + total) % total;
      this.track.scrollTo({
        left: this.slides[this.index].offsetLeft,
        behavior: 'smooth',
      });
      this.updateDots();
    }

    syncFromScroll() {
      const width = this.track.clientWidth;
      if (!width) return;
      this.index = Math.round(this.track.scrollLeft / width);
      this.updateDots();
    }

    updateDots() {
      this.dots.forEach((dot, dotIndex) => {
        dot.classList.toggle('is-active', dotIndex === this.index);
      });
    }

    startAutoplay() {
      this.stopAutoplay();
      const speed = Number(this.dataset.autoplaySpeed) || 5000;
      this.autoplayTimer = window.setInterval(() => this.goTo(this.index + 1), speed);
    }

    stopAutoplay() {
      window.clearInterval(this.autoplayTimer);
    }
  }

  if (!customElements.get('perfume-hero-slider')) {
    customElements.define('perfume-hero-slider', PerfumeHeroSlider);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["perfume-product-carousel"] && !Shopify.designMode) return;
  try {
    
  class PerfumeProductCarousel extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('[data-pf-carousel-track]');
      this.prev = this.querySelector('[data-pf-carousel-prev]');
      this.next = this.querySelector('[data-pf-carousel-next]');
      if (!this.track) return;
      if (this.prev) this.prev.addEventListener('click', () => this.move(-1));
      if (this.next) this.next.addEventListener('click', () => this.move(1));
    }

    move(direction) {
      const item = this.track.querySelector('.pf-product-carousel__item');
      const distance = item ? item.clientWidth + 18 : 280;
      this.track.scrollBy({ left: distance * direction, behavior: 'smooth' });
    }
  }

  if (!customElements.get('perfume-product-carousel')) {
    customElements.define('perfume-product-carousel', PerfumeProductCarousel);
  }

  } catch(e) { console.error(e); }
})();
})();
